import { AlertColor } from "@mui/material";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum NotificationOpenType {
    Introduction = "Introduction",
    ExportRoom = "exportRoom",
    ResetRoom = "resetRoom",
    SaveRoom = "saveRoom",
    LoadSetup = "loadSetup",
    NewSetup = "newSetup",
    Null = "null",
    Logout = "logout",
    ReportIssue = "reportIssue",
    ChangePatient = "changePatient",
    SaveSceneJson = "saveSceneJson",
    Import = "import",
}

export type NotificationSliceType = {
    id?: string;
    isNotificationOpen: boolean;
    text: string;
    type?: AlertColor;
};

const initialState = {
    isNotificationOpen: false,
    text: "",
} as NotificationSliceType;

const NotificationSlice = createSlice({
    name: "Notification",
    initialState: initialState,
    reducers: {
        openNotification: (state, action: PayloadAction<NotificationSliceType>) => {
            state.isNotificationOpen = action.payload.isNotificationOpen;
            state.type = action.payload.type ?? state.type;
            state.text = action.payload.text ?? state.text;
            state.id =
                action.payload.id ?? action.payload.isNotificationOpen
                    ? `${Date.now()}-${Math.random()}`
                    : state.id;
        },
    },
});

export const { openNotification } = NotificationSlice.actions;

export default NotificationSlice.reducer;
